/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';

export interface AppConfig {
    production: string;
    appName: string;
    authKey: string;
    appVersion?: string;
    appVersionCodename?: string;
    apiMap: ApiMap;
    buildNumber: string;
    environmentName?: string;
    baseUrl: string;
    auth: AuthConfig;
}

export interface AuthConfig {
    enabled: boolean;
    issuer?: string;
    clientId?: string;
    redirectUri: string;
    responseType: string;
    scope?: string;
    showDebugInformation: boolean;
    strictDiscoveryDocumentValidation: boolean;
    preserveRequestedRoute: boolean;
}

export interface ApiMap {
    vacationTrackerApi: string;
}

/**
 * This service loads environment specific configuration.
 */
@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private appConfig: AppConfig | undefined;

    constructor(private readonly http: HttpClient) {
    }

    loadAppConfig(): Promise<void | AppConfig> {
        return lastValueFrom(this.http.get<AppConfig>('/assets/config/appConfig.json'))
            .then(data => {
                this.appConfig = data;
                this.appConfig.auth.redirectUri = window.location.origin;
            });
    }

    getConfig(): AppConfig {
        return <AppConfig>this.appConfig;
    }
}
